var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/** @jsx jsx */
import { jsx } from 'theme-ui';
import { createOverridableComponent } from '../util/OverridableComponent';
import { useThemeStyle } from '../hooks/useThemeStyle';
import { OverflowMenu } from './OverflowMenu';
export var Card = createOverridableComponent('div', function (_a, Component, ref) {
    var children = _a.children, actions = _a.actions, props = __rest(_a, ["children", "actions"]);
    var css = useThemeStyle('card', {
        bg: 'background',
        borderStyle: 'solid',
        borderWidth: 1,
        borderColor: 'grey',
        borderRadius: 3,
    });
    return (jsx(Component, __assign({}, props, { ref: ref, css: css }),
        actions && (jsx(OverflowMenu, { sx: { position: 'absolute', right: 0, top: '5px' } }, actions)),
        children));
});
//# sourceMappingURL=Card.js.map